import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { successOpen, updateUser } from '@app-modules/feature/editprofile/editprofile.component';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { SignupService } from '@app-services/signup/signup.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { BoardsDialogComponent } from '../boards-dialog/boards-dialog.component';
import { GradesdialogComponent } from '../gradesdialog/gradesdialog.component';
import { navigateBetweenProjects } from 'src/app/helpers/functions';
import { dashboardRoute } from '@app-constants/app.constants';

@Component({
  selector: 'app-exam-dialog',
  templateUrl: './exam-dialog.component.html',
  styleUrls: ['./exam-dialog.component.css']
})
export class ExamDialogComponent implements OnInit {
  examForm: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  searchIndices: any = [];
  allSearchIndices: any = [];
  selectedExams: any = [];
  greenTickPath = 'assets/img/green-tick-icon.svg';
  greyTickPath = 'assets/img/grey-tick-icon.svg';
  exams:any = [];
  user:any;
  exams1: any = [];

  constructor(private dialogRef: MatDialogRef<ExamDialogComponent>, private dialog: MatDialog, private _formBuilder: FormBuilder, private targetExamService: BoardsService,
    @Inject(MAT_DIALOG_DATA) public data: any, private userService: UserService, private gaService: GAnalyticsService, public signUpService: SignupService, private router: Router, private testListService: TestlistService, private spinner: NgxSpinnerService) {
      this.data.isExamEdit = this.data.isExamEdit || this.data.setupAccountImposed;
      dialogRef.disableClose = !this.data.isExamEdit;
  }

  ngOnInit(): void {
    console.log('diaalog data', this.data);
    this.getTargetExamsList();
    if (this.data.exams) {
      this.exams1 = this.data.exams;
    }
  }

  getTargetExamsList() {
    const isExamEdit = this.data.isExamEdit;
    this.targetExamService.fetchTargetExamList().subscribe((data: any) => {
      this.exams = data;
      console.log('exams', this.exams)
      this.examsSelected()
    });
  }

  examsSelected(): void {
    //console.log(this.exams, this.exams1)
    for(let i =0, len = this.exams.length; i< len; i++ ) {
      this.searchIndices.push(i);
      // if (this.exams[i].name=='School Exams' ||this.exams[i].name=='NEET') {
      //   this.selectedExams[i] = true;
      // }
      for(let j =0, len = this.exams1.length; j< len; j++ ) {
        if(this.exams1[j].examId === this.exams[i].examId){
          this.selectExam(i)
        }
      }
    }
    this.allSearchIndices = this.searchIndices;
}

  selectExam(i: any) {
    this.selectedExams[i] = !this.selectedExams[i]
  }

  searchExams(event: KeyboardEvent) {
    const searchString = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if(searchString == "") {
      this.searchIndices = this.allSearchIndices
    } else {
      const res: any = [];
      const exams = this.exams;
      for(let i = 0, len = exams.length; i < len; i++) {
        if(exams[i].name.toLowerCase().indexOf(searchString) >  -1 || exams[i].description.toLowerCase().indexOf(searchString) > -1) {
          res.push(i);
        } else {
          this.selectedExams[i] = false;
        }
      }
      this.searchIndices = res;
    }
  }

  navigateBetweenProjects() {
    const exams: any = [];
    const webengageExam = [];
    for (let i = 0, len = this.exams.length; i < len; i++) {
      if (this.selectedExams[i]) {
        exams.push(this.exams[i]);
        webengageExam.push(this.exams[i].name);
      }
    }
    if(!exams.length) return;
    const mobileAndName = this.userService.getMobileAndName();

    const userData = {
      personalDetails: {...mobileAndName},
      accountDetails: this.data.accountDetails,
      selectedStream:this.data.selectedStream,
      grade: this.data.grade,
      board: this.data.board,
      exams: exams
    }
    console.log(this.selectedExams);
    this.gaService.sendEvent(
      'Course Selected (Setup Account)',
      '',
      '',
      '',
      {
        'event': 'Course Selected (Setup Account)',
        'Phone Number': userData?.personalDetails?.phone,
        'First Name': userData?.personalDetails?.firstName,
        'Last Name': userData?.personalDetails?.lastName,
        'City': '',
        'Email ID': userData?.accountDetails?.email,
        'Course Name': webengageExam,
      }
    )
    this.registerUser(userData);
  }

  registerUser(userData: any): void {
    //remove || from below condition when register API(serviceMethod) is working fine
    const setupAccountImposed = this.data.setupAccountImposed || true;
    //const obj = setupAccountImposed ? this.formatRegisterObjectForUpdate(userData): this.formatRegisterObject(userData);
    const obj = setupAccountImposed ? this.formatRegisterObjectForUpdate(userData): this.formatRegisterObject(userData);
    if(setupAccountImposed) {
      obj.userId = userData.personalDetails.userId;
    }
    const service = setupAccountImposed ? this.userService: this.signUpService;
    const serviceMethod = setupAccountImposed ? 'updateUserDetails': 'register';
    service[serviceMethod](obj).subscribe((data: any) => {
      if(data){
        const dto = setupAccountImposed ? data.userDto : data;
        this.userService.updateRequestedUserData(dto);
        let gradeByName = dto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        this.userService.setMobileAndName({phone: dto.phone, isdCode: dto.isdCode, firstName: dto.firstName, lastName: dto.lastName,
          whatsappConsent: dto.whatsappConsent, userId: dto.userId, profilePhoto:dto.profilePhoto, grade: Number(gradeByName)});
          this.userService.setUserTypes(dto.userType);
        if(false) {
          let body = [];
          body.push({ Attribute: 'FirstName', Value: data.userDto.firstName,  });
          body.push({ Attribute: 'LastName', Value: data.userDto.lastName});
          body.push({ Attribute: 'Phone', Value: data.userDto.phone });
          body.push({ Attribute: 'Grade', Value: data.userDto?.grade?.name });
          body.push({ Attribute: 'Email', Value: data.userDto?.email });
          body.push({ Attribute: 'Exams', Value: data.userDto?.exams?.map(e => e?.name).join(', ') });
          body.push({ Attribute: 'SearchBy', Value: 'Phone'})
          this.signUpService.leadSquaredJee(body);   
        }
        this.dialogRef.close();
        if(this.data?.actionData?.redirection){
          //this.router.navigate([this.data?.actionData?.redirection]);
          navigateBetweenProjects(this.router, this.data?.actionData?.redirection);
        } else {
          navigateBetweenProjects(this.router, dashboardRoute);
        }
      } else {
        alert("Some issue occurred in updating the details");
      }
        
      },
      (error: any) => {                                     // on error
        alert(error.error.message);
      });
  }

  formatRegisterObject(value:any): any {
    const obj = {
      board: value.board,
      email: value.accountDetails.email,
      firstName: value.personalDetails.firstName,
      grade: value.grade,
      isdCode: value.personalDetails.isdCode,
      lastName: value.personalDetails.lastName,
      password: value.accountDetails.password,
      phone: value.personalDetails.phone,
      exams: value.exams,
      stream:(value.selectedStream!=null && value.selectedStream!='')?{streamId:value.selectedStream}:null,
      // userType: {"userTypeId": 2},
      whatsappConsent: value.personalDetails.whatsappConsent
    }
    return obj;
  }
  
  formatRegisterObjectForUpdate(value:any): any {
    const obj = {
      board: value.board,
      email: value.accountDetails.email,
      firstName: value.personalDetails.firstName,
      grade: value.grade,
      isdCode: value.personalDetails.isdCode,
      lastName: value.personalDetails.lastName,
      password: value.accountDetails.password,
      phone: value.personalDetails.phone,
      exams: value.exams,
      stream:(value.selectedStream!=null && value.selectedStream!='')?{streamId:value.selectedStream}:null,
      whatsappConsent: value.personalDetails.whatsappConsent,    
      lastLoggedInTime: value.personalDetails.lastLoggedInTime,
      profilePhoto: value.personalDetails.profilePhoto,
      isProfileComplete: value.personalDetails.isProfileComplete,
      country: value.personalDetails.country,
      userType: value.personalDetails.userType ? {
        userTypeId: [value.personalDetails.userType.userTypeId],
        name: [value.personalDetails.userType.name]
      }: null,
      userId: value.personalDetails.userId
    }
    return obj;
  }
  
   // }
  showPrevStep() {
      this.dialogRef.close();

      const config: MatDialogConfig = {
        maxWidth:"570px",
        //height: '100%',
          panelClass:'mat-full',
          data: {
          message:'Great, your account is almost ready',
          message2: 'Help us with your academic details, so we can curate content specially for you',
          // message3: 'What grade are you in',
            accountDetails: this.data.accountDetails,
            grade: this.data.grade,
            selectedStream: '',//this.data.selectedStream,
            actionData: this.data?.actionData,
            setupAccountImposed: this.data.setupAccountImposed
          }
      };
      const dialogRef = this.dialog.open(GradesdialogComponent, config);
  }

  onConfirmClick(): void {
    if(this.data.setupAccountImposed) {
      this.navigateBetweenProjects()
    }
    else if (this.data.isExamEdit) {
      const exams:any = [];
      for(let i =0, len = this.exams.length; i< len; i++ ) {
        if(this.selectedExams[i]) {
          exams.push(this.exams[i]);
        }
      }
      if(!exams.length) return;
      
      updateUser.call(this, [{name: 'exams', value: exams}], () => {
        
        successOpen.call(this, 'Profile Updated' ,`Target exams information has been updated  successfully`, () => this.dialogRef.close(exams));
      })
      
    }
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

}
